import React from 'react';
import PropTypes from 'prop-types';
import styles from './FormPreviewTemplate.css';
import { useParams } from 'react-router';

function FormPreviewTemplate({ drawer = false }) {
  const { formId } = useParams();
  return <div className={styles.FormPreviewTemplate}>{`Displaying form ${formId}`}</div>;
}
FormPreviewTemplate.propTypes = {
  drawer: PropTypes.bool,
  formId: PropTypes.string,
};

export default FormPreviewTemplate;
